import { languageMap } from ".."
import { markupLanguage } from "./shared"

languageMap.xeoracube = languageMap.xeora = markupLanguage()
